const $inject = ['$rootScope', '$q', '$http', 'cartService', 'apiService', 'itinerariesService'];

const unusedTicketsService = ($rootScope, $q, $http, cartService, apiService, itinerariesService) => {
  const service = {
    isActive: false,
    isEnabled: true,
    tickets: [],
    getTickets: getTickets,
    toggle: toggle,
    clear: clear,
  };

  $rootScope.$watchCollection(() => cartService.items, validate);
  $rootScope.$watchCollection(() => cartService.tickets, validate);

  return service;

  function getTickets() {
    const deferred = $q.defer();
    service.clear();

    try {
      // JLF 2018-09-07 use the itinerary service instead
      for (let paxIndex in itinerariesService.itinerary.Search.Passengers) {
        for (let uutcIndex in itinerariesService.itinerary.Search.Passengers[paxIndex].UnusedTicketCredits) {
          const ticket = itinerariesService.itinerary.Search.Passengers[paxIndex].UnusedTicketCredits[uutcIndex];

          service.tickets.push({
            BookingCode: 'UUTC',
            Carrier: ticket.AirLineCode,
            CarrierLogoUrl: ticket.CarrierImage,
            ClientId: ticket.PassengerId,
            Comment: `UUTC - ${itinerariesService.itinerary.Search.Passengers[paxIndex].DepartmentCode}`, // TODO: update this to be more accurate
            DebtorName: itinerariesService.itinerary.Search.Passengers[paxIndex].DepartmentName, // TODO: update this to be more accurate
            DestinationCityCode: 'NA', // Not Applicable
            EffectiveDate: ticket.EffectiveDate,
            ExpiryDate: ticket.ExpirationDate,
            GDSId: ticket.GDSId,
            OriginCityCode: 'NA', // Not Applicable
            Currency: ticket.Currency,
            PassengerIdentifier: ticket.PassengerIdentifier,
            TicketNumber: service.tickets.length + 1,
            Traveller: itinerariesService.itinerary.Search.Passengers[paxIndex].FullName,
            Value: ticket.Amount,
            isDisabled: true,
            UseCredit: ticket.UseCredit,
          });
        }

        deferred.resolve(service.tickets);
        validate();
      }
    } catch (ex) {
      service.clear();
      console.error('unusedTicketsService.getTickets', ex.toString());
      deferred.reject(ex);
    }

    return deferred.promise;
  }

  function validate() {
    const orderedTickets = _.orderBy(service.tickets, 'Amount');

    orderedTickets.forEach((ticket) => {
      const matchingTicket = cartService.getMatchingTicket(ticket);

      ticket.isDisabled = !_.some(cartService.items, (item) => {
        return item.type == 'flight' && item.result.Carrier === ticket.Carrier;
      });

      if (ticket.isDisabled || !matchingTicket) {
        cartService.removeTicket(ticket);
      }
    });
  }

  function toggle() {
    service.isActive = !service.isActive;
  }

  function clear() {
    service.isActive = false;
    service.tickets = [];
  }
};

unusedTicketsService.$inject = $inject;

export default unusedTicketsService;



// WEBPACK FOOTER //
// ./src/services/unusedTicketsService.js